import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'ウルトラファインバブルとは何ですか？',
      answer: 'ウルトラファインバブルとは、1μm（マイクロメートル）以下の非常に小さな気泡のことです。通常の気泡と異なり、長時間水中に留まり、洗浄力の向上や美容効果など様々な効果が期待できます。',
    },
    {
      question: '設置にはどのくらいの時間がかかりますか？',
      answer: '通常、設置工事は2〜3時間程度で完了します。ただし、設置場所の状況によって異なる場合がございますので、事前の現地調査時に詳しくご説明いたします。',
    },
    {
      question: 'メンテナンスは必要ですか？',
      answer: 'UFB DUALは基本的にメンテナンスフリーです。特別なお手入れは不要で、長期間安定してご使用いただけます。',
    },
    {
      question: '既存の設備を変更する必要はありますか？',
      answer: 'いいえ、既存のシャワーヘッドや洗濯機などを変更する必要はありません。水道の配管に取り付けるだけで、家全体の水がウルトラファインバブル水になります。',
    },
    {
      question: '飲用水としても使えますか？',
      answer: 'はい、UFB DUALは飲用適水テストに合格しており、安心して飲用水としてもご使用いただけます。',
    },
    {
      question: '効果はどのくらいで実感できますか？',
      answer: '個人差はありますが、多くのお客様が設置後すぐに水の感触の違いを実感されています。洗浄効果や美容効果は継続的にご使用いただくことでより実感していただけます。',
    },
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-blue-50 to-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5">
        <div className="absolute top-20 right-20 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="text-blue-500 font-semibold text-sm uppercase tracking-wider mb-2">FAQ</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">よくあるご質問</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <div className="flex items-start flex-1">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full mr-4 flex-shrink-0 text-sm font-bold">
                    Q
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 flex-1">{faq.question}</h3>
                </div>
                <div className={`w-8 h-8 flex items-center justify-center text-blue-500 text-2xl transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 pl-18">
                  <div className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-cyan-500 text-white rounded-full mr-4 flex-shrink-0 text-sm font-bold">
                      A
                    </div>
                    <p className="text-gray-600 leading-relaxed flex-1">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">その他のご質問がございましたら、お気軽にお問い合わせください。</p>
          <a
            href="#contact"
            className="inline-block bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            お問い合わせはこちら
          </a>
        </div>
      </div>
    </section>
  );
}
